var render, staticRenderFns
import script from "./form_detail.vue?vue&type=script&lang=js"
export * from "./form_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2c0ea2')) {
      api.createRecord('6d2c0ea2', component.options)
    } else {
      api.reload('6d2c0ea2', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/check_in_details_report/form_detail.vue"
export default component.exports